import React from 'react';
import { autobind } from 'core-decorators';
import Button from '../../componentes/button';
import ColaboradorList from './view';
import ContentManager from '../../componentes/content-manager';
import IconButton from '../../componentes/icon-button';
import Table from '../../componentes/table';
import { FormGroup, Alert } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';
import Panel from '../../componentes/panel';
import { injectIntl } from 'react-intl';
import { capitalizeFirstLetter } from '../../utils/string';
import { connect } from 'react-redux';
import LucideIcon from 'src/componentes/lucide-icon';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';

@autobind
class ColaboradorSelectList extends React.Component {
  static defaultProps = {
    showPage: true,
    pageSize: null,
    forcarPageSize: false,
    permitirSelecionarTodos: false,
    height: '300px',
  };

  constructor(props) {
    super(props);
    this.state = {
      ehSelecaoTotal: false,
      colaboradoresExcluidosIds: [],
      colaboradoresIds: [],
      listModel: null,
    };
  }

  handleNewClick() {
    let { resources, showPage, pageSize } = this.props;
    ContentManager.addContent(
      <ColaboradorList
        pageSize={pageSize}
        showPage={showPage}
        forcarPageSize={this.props.forcarPageSize}
        showModal
        multiple
        parameters={{ somenteAtivos: this.props.somenteAtivos }}
        select={true}
        tag=""
        showExport={false}
        titulo={capitalizeFirstLetter(resources.colaboradores)}
        selectedCallback={this.handleSelect}
        selectedIds={this.props.model.value}
        selectedItems={this.props.model.value}
        filtroInterno={this.props.filtroInterno}
        permitirSelecionarTodos={this.props.permitirSelecionarTodos}
        ehSelecaoTotal={
          !!this.state.ehSelecaoTotal && !this.state.listModel?.searchText
        }
        excludedIds={this.state.colaboradoresExcluidosIds}
      />
    );
  }

  processarColaboradores(colaboradores) {
    this.setState({
      colaboradoresIds: colaboradores.map((colaborador) => colaborador.id),
    });
  }

  handleSelect(colaboradores, selection = {}) {
    if (this.props.permitirSelecionarTodos) {
      const ehSelecaoTotal = !!selection.ehSelecaoTotal;
      const colaboradoresExcluidosIds = selection.excludedIds || [];

      this.setState({
        ehSelecaoTotal,
        colaboradoresExcluidosIds: colaboradoresExcluidosIds,
        listModel: ehSelecaoTotal ? selection.model || null : null,
      });

      const colaboradoresSelecionados = [...colaboradores];

      this.props.model.requestChange(colaboradoresSelecionados, selection);
      this.processarColaboradores(colaboradoresSelecionados);
      return;
    }

    this.props.model.requestChange([...colaboradores]);
  }

  handleRemove(colaborador) {
    const next = this.props.model.value.filter((d) => d.id !== colaborador.id);

    if (this.props.permitirSelecionarTodos && this.state.ehSelecaoTotal) {
      const colaboradoresExcluidos = [
        ...this.state.colaboradoresExcluidosIds,
        colaborador.id,
      ];

      this.setState({ colaboradoresExcluidosIds: colaboradoresExcluidos });
      this.props.model.requestChange(next, {
        ehSelecaoTotal: true,
        excludedIds: colaboradoresExcluidos,
      });
      this.processarColaboradores(next);
      return;
    }

    this.props.model.requestChange(next);
    if (this.props.permitirSelecionarTodos) {
      this.processarColaboradores(next);
    }
  }

  renderRemoverColaborador = (item) => {
    return (
      <IconButton
        icon="close-circle"
        className="clarear"
        onClick={this.handleRemove.bind(this, item)}
      />
    );
  };

  render() {
    let { model, disabled, resources } = this.props;

    return (
      <FormGroup
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          height: this.props.height,
        }}
        validationstate={model.errors ? 'error' : null}
      >
        <Row>
          <Col md={6}>
            {model.label && (
              <label className="control-label">{model.label}</label>
            )}
          </Col>
          <Col md={6}>
            {!disabled && (
              <Button
                size="icon"
                className="pull-right"
                style={{ marginBottom: 10 }}
                onClick={this.handleNewClick}
              >
                <LucideIcon icon="plus" />
              </Button>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {model.value && model.value.length > 0 ? (
              this.props.permitirSelecionarTodos ? (
                <List
                  url="/Colaborador"
                  showSearch={true}
                  actionsColumn="nome"
                  titulo={capitalizeFirstLetter(resources.colaboradores)}
                  sort="nome"
                  showFilter={true}
                  showMenu={false}
                  showEdit={false}
                  showDelete={false}
                  showNew={false}
                  showExport={false}
                  filtroInterno={{ filtrarEmailNotNull: true }}
                  forceSelectedFilter={
                    this.state.ehSelecaoTotal && !!this.state.listModel
                  }
                  selectedFilter={
                    this.state.ehSelecaoTotal && this.state.listModel
                      ? { valor: this.state.listModel }
                      : undefined
                  }
                  hideFiltroChip
                  parameters={{
                    somenteAtivos: this.props.somenteAtivos,
                    colaboradoresIds: this.state.ehSelecaoTotal
                      ? []
                      : this.state.colaboradoresIds,
                    ignorarIds: this.state.colaboradoresExcluidosIds,
                  }}
                  saved={this.state.colaboradoresIds}
                >
                  <ListColumn
                    headerText={this.props.intl.formatMessage({ id: 'nome' })}
                    valueField="nome"
                    sortField="nome"
                    required
                    default
                  />
                  <ListColumn
                    headerText={this.props.intl.formatMessage({
                      id: 'email',
                    })}
                    valueField="email"
                    sortField="email"
                    default
                  />
                  <ListColumn
                    headerText={''}
                    valueField="acoes"
                    valueFunction={this.renderRemoverColaborador}
                    default
                  />
                </List>
              ) : (
                <Panel>
                  <Table>
                    <tbody>
                      {model.value.map((item, index) => (
                        <tr key={index}>
                          <td>{item.nome}</td>
                          <td>{item.gestorSubstituto}</td>
                          <td style={{ width: 40 }}>
                            <IconButton
                              icon="close-circle"
                              className="clarear"
                              onClick={this.handleRemove.bind(this, item)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Panel>
              )
            ) : (
              <Panel>
                <i>
                  {this.props.intl.formatMessage(
                    { id: 'label.semColabRelacionados' },
                    { colaboradores: resources.colaboradores }
                  )}
                </i>
              </Panel>
            )}
          </Col>
        </Row>
        {model.erros && <Alert>{model.erros}</Alert>}
      </FormGroup>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(ColaboradorSelectList));
